import React from 'react';

interface SuggestionSkeletonProps {
  count?: number;
}

const SuggestionSkeleton: React.FC<SuggestionSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className='space-y-2 pt-3'>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className='w-full p-3 bg-gray-100 rounded-lg animate-pulse'
          style={{ animationDelay: `${idx * 150}ms` }}
        >
          <div className='flex items-start gap-2'>
            <div className='flex-shrink-0 mt-0.5'>
              <div className='w-4 h-4 bg-gray-300 rounded-sm' />
            </div>
            <div className='flex-1 space-y-2'>
              <div className='h-3 bg-gray-300 rounded w-full' />
              <div className='h-3 bg-gray-300 rounded w-3/4' />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SuggestionSkeleton;
